import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUIControlsStore } from '../redux/features/ui-controls';
import { useDispatch } from 'react-redux';
import { useAuthStore } from '../redux';
import { clearState } from '../redux/features/prePanJourneySlice';
import Event from '../utils/eventTracker';
import FullScreenBackdropLoader from './full-screen-backdrop-loader';

const LogoutConfirmModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { showLogoutPopupModal, updateShowLogoutModalFlag } =
    useUIControlsStore();
  const { customerId, customerRefNum, Authorization, logoutAPICall } =
    useAuthStore();
  const [isLoading, setIsLoading] = useState(false);

  const yesButtonClicked = async () => {
    setIsLoading(true);
    Event('Logout');
    // window.location.href = window.location.origin;
    // let source = 'WEB'
    (async () => {
      try {
        await logoutAPICall({
          customerId,
          customerRefNum,
          Authorization,
          source: 'WEB',
          successFn: () => {},
          errorFn: () => {},
          finallyFn: () => {
            // need to await to be entirely sure localStorage is cleared
            dispatch(clearState());
            navigate('/');
            localStorage.clear();
            setIsLoading(false);
          },
        });
      } catch (err) {
        console.log('Error while log out', err);

        dispatch(clearState());
        localStorage.clear();
        navigate('/');

        setIsLoading(false);
      }
    })();
    updateShowLogoutModalFlag(false);
  };

  const noButtonClicked = () => {
    updateShowLogoutModalFlag(false);
  };

  return (
    <>
      <FullScreenBackdropLoader isLoading={isLoading} />
      {showLogoutPopupModal ? (
        <>
          <div
            className="res150-overlay fixed top-0 left-0 right-0 bottom-0 w-full h-full  overflow-hidden bg-gray-700 opacity-100 flex flex-col items-center justify-center p-2"
            style={{ background: 'rgb(0,0,0,0.8)', zIndex: 50 }}
          >
            <div className="bg-background-primary rounded-lg flex flex-col m-auto p-3">
              {' '}
              <div className="max-w-[300px] text-center w-full flex flex-col justify-center items-center p-3">
                <p className="font-normal">Are you sure you want to logout</p>
              </div>
              <div className="flex flex-row justify-center items-center">
                <button
                  id="yesquit4"
                  className="bg-[#079F9F] text-white inline-block m-1 px-2 py-2  rounded-lg text-sm font-semibold focus:outline-none tracking-wider bg-accent text-text-light hover:bg-btn-active disabled:bg-[#045656] active:bg-btn-active transition duration-200 ease-in-out w-32"
                  onClick={noButtonClicked}
                >
                  No, continue
                </button>
                <button
                  id="Logout1"
                  style={{
                    color: '#079F9F',
                    border: '1px solid #079F9F',
                    borderRadius: '5px',
                  }}
                  className="bg-background-primary inline-block m-1 px-2 py-2  rounded-lg text-sm font-semibold focus:outline-none tracking-wider transition duration-200 ease-in-out w-32"
                  onClick={yesButtonClicked}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        ''
      )}
    </>
  );
};

export default LogoutConfirmModal;
